import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { rememberMemberEmail } from "@/lib/memberEmail";

const EMAIL_RE = /\S+@\S+\.\S+/;

/** Looks up membership perks for an email once it looks valid (debounced). Returns null while unknown. Remembers member emails on this device. */
export function useMemberCheck(email) {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    const clean = (email || "").trim().toLowerCase();
    if (!EMAIL_RE.test(clean)) { setInfo(null); return; }
    const t = setTimeout(() => {
      api.get("/memberships/check", { params: { email: clean } }).then((r) => {
        setInfo(r.data);
        if (r.data.member) rememberMemberEmail(clean);
      }).catch(() => setInfo(null));
    }, 500);
    return () => clearTimeout(t);
  }, [email]);
  return info;
}
